import React, { ElementType } from "react"
import { get } from "lodash-es"
interface CellData<T> {
  value: any
  original: T
}

interface FooterData<T> {
  data: T[]
}
interface ColumnType<T> {
  header?: string
  accessor: string | string[]
  Cell: (cell: CellData<T>) => ElementType | string | null
  Footer?: (cell: FooterData<T>) => ElementType | string | null
  colSpan?: number
}
interface InfoTableProps<T> {
  /**
   * @default id
   */
  uniqueId?: string
  data: T[]
  columns: ColumnType<T>[]
}
const InfoTable = ({ data, columns, uniqueId = "id" }: InfoTableProps<any>) => {
  return (
    <table className="vt-bulk-update-summary-table pr-6">
      <thead className="vt-bulk-update-table-header">
        <tr>
          {columns.map((c, idx) => {
            return <th key={idx}>{c.header}</th>
          })}
        </tr>
      </thead>
      <tbody className="vt-bulk-update-table-body">
        {data.map((row, idx) => {
          return (
            <tr key={row[uniqueId] ?? idx}>
              {columns.map((c, col) => {
                return (
                  <td key={col}>
                    {c.Cell({ value: get(row, c.accessor), original: row })}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        {columns?.some(c => c.Footer) && (
          <tr>
            {columns.map((c, col) => {
              return (
                <td key={col} colSpan={c.colSpan}>
                  {c.Footer?.({ data })}
                </td>
              )
            })}
          </tr>
        )}
      </tfoot>
    </table>
  )
}
InfoTable.defaultProps = {
  uniqueId: "id",
}
export default InfoTable
